import { render, staticRenderFns } from "./pModal.vue?vue&type=template&id=22c61f93&scoped=true&"
import script from "./pModal.vue?vue&type=script&lang=js&"
export * from "./pModal.vue?vue&type=script&lang=js&"
import style0 from "./pModal.vue?vue&type=style&index=0&id=22c61f93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c61f93",
  null
  
)

export default component.exports